var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name === _vm.currentKey && _vm.asc)?_c('i',{staticClass:"fas fa-sort-up"}):(_vm.name === _vm.currentKey)?_c('i',{staticClass:"fas fa-sort-down"}):_c('i',{staticClass:"fas fa-sort text-secondary"})}
var staticRenderFns = []

export { render, staticRenderFns }